import React from "react";

function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#1890FF"
        d="M9 2a7 7 0 10.001 14.001A7 7 0 009 2zm.5 10.375a.125.125 0 01-.125.125h-.75a.125.125 0 01-.125-.125v-4.25c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125v4.25zM9 7a.75.75 0 010-1.5A.75.75 0 019 7z"
      ></path>
    </svg>
  );
}

export default InfoIcon;